export default function BasketJar() {
    return {
        currentBookings: [],
        activity: null,
        location: null,
    };
}
